import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { ChangeDetectorRef, Component, HostBinding, Injector } from '@angular/core';
import { TOAST_DATA_INJECTION_TOKEN, ToastBaseComponent, ToastDataBaseComponent } from '../toast-base.component';
import { AppToast, ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-toast-host',
  templateUrl: './toast-host.component.html',
  styleUrls: ['./toast-host.component.scss'],
  standalone: false
})
export class ToastHostComponent {
  constructor(private injector: Injector, private changeDetectionRef: ChangeDetectorRef) { }
  toastService: ToastService;
  activeToasts: Toast[] = [];

  @HostBinding('class')
  hostClass: string;

  orientations: string[] = ["align-top-right","align-top-left","align-bottom-right","align-bottom-left"]

  setOrientation(index: number) {
    this.hostClass = this.orientations[index];
    this.changeDetectionRef.detectChanges();
  }

  addToast<T extends ToastBaseComponent<D>, D extends ToastDataBaseComponent>(toast: AppToast<T, D>) {
    let element = { component: toast.component, injector: null };
    this.activeToasts.push(element);
    let index = this.activeToasts.indexOf(element);

    toast.data.host = this;
    toast.data.index = index;

    this.activeToasts[index].injector = Injector.create({
      providers: [{ provide: TOAST_DATA_INJECTION_TOKEN, useValue: toast.data }],
      parent: this.injector
    })

    return index;
  }

  removeToast(index: number) {
    this.activeToasts.splice(index)
  }

  dismissToast(index: number) {
    this.toastService.dismiss(index, false);
  }
}

interface Toast <T = ToastBaseComponent<any>>{component: ComponentType<T>, injector: Injector}
